import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import './AuthPages.css';

export default function ClientAcceptInvite() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get('token');

  const [info, setInfo]         = useState(null);
  const [error, setError]       = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm]   = useState('');
  const [loading, setLoading]   = useState(true);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (!token) { setError('No invite token provided.'); setLoading(false); return; }
    fetch(`/api/client-portal/invite-info?token=${token}`)
      .then(r => r.json())
      .then(data => {
        if (data.error) setError(data.error);
        else setInfo(data);
      })
      .catch(() => setError('Failed to load invite.'))
      .finally(() => setLoading(false));
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password.length < 8) return setError('Password must be at least 8 characters.');
    if (password !== confirm) return setError('Passwords do not match.');
    setSubmitting(true); setError('');
    try {
      const res = await fetch('/api/client-portal/accept-invite', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, password }),
      });
      const data = await res.json();
      if (!res.ok) return setError(data.error || 'Failed to set up account.');
      localStorage.setItem('clientToken', data.token);
      localStorage.setItem('clientDealId', data.dealId);
      navigate('/client/portal');
    } catch { setError('Something went wrong. Please try again.'); }
    finally { setSubmitting(false); }
  };

  if (loading) return <div className="auth-page"><div className="auth-card"><p>Loading…</p></div></div>;

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-logo">BrokerConnect</div>
        {error ? (
          <>
            <div className="auth-error">{error}</div>
            <p style={{ textAlign: 'center', fontSize: 14, color: '#718096' }}>
              Please contact your broker for a new invite link.
            </p>
          </>
        ) : (
          <>
            <h1 className="auth-title">Set Up Your Account</h1>
            <p className="auth-subtitle">
              {info?.company_name} has requested documents for <strong>{info?.client_name}</strong>'s application.
              Create a password to access your secure upload portal.
            </p>
            {info?.docTypes?.length > 0 && (
              <div style={{ background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: 8, padding: '12px 16px', marginBottom: 20 }}>
                <p style={{ margin: '0 0 8px', fontSize: 13, fontWeight: 600, color: '#065f46' }}>Documents requested:</p>
                {info.docTypes.map(dt => (
                  <div key={dt.id} style={{ fontSize: 13, color: '#0e1b2c', padding: '2px 0' }}>✓ {dt.name}</div>
                ))}
              </div>
            )}
            <form onSubmit={handleSubmit}>
              <div className="auth-field">
                <label>Email</label>
                <input type="email" value={info?.email || ''} disabled className="auth-input" />
              </div>
              <div className="auth-field">
                <label>Create Password</label>
                <input type="password" value={password} onChange={e => setPassword(e.target.value)}
                  placeholder="Minimum 8 characters" className="auth-input" required />
              </div>
              <div className="auth-field">
                <label>Confirm Password</label>
                <input type="password" value={confirm} onChange={e => setConfirm(e.target.value)}
                  className="auth-input" required />
              </div>
              {error && <div className="auth-error">{error}</div>}
              <button type="submit" className="auth-btn" disabled={submitting}>
                {submitting ? 'Setting up…' : 'Create Account & Continue'}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
